/** Поле поиска с кнопкой очистки; по Esc очищает запрос, не закрывая панель. */
import type { ComponentPropsWithoutRef } from "react";

type SearchInputProps = Omit<ComponentPropsWithoutRef<"input">, "type" | "value" | "onChange"> & {
	value: string;
	onChange: (value: string) => void;
};

export const SearchInput = ({
	value,
	onChange,
	placeholder = "Поиск…",
	className = "",
	onKeyDown,
	...props
}: SearchInputProps) => (
	<div className={`relative ${className}`}>
		<input
			type="text"
			value={value}
			onChange={(event) => onChange(event.target.value)}
			onKeyDown={(event) => {
				if (event.key === "Escape" && value) {
					event.stopPropagation();
					onChange("");
				}
				onKeyDown?.(event);
			}}
			placeholder={placeholder}
			className="w-full rounded-md border border-border bg-surface px-2.5 py-1.5 pr-7 text-xs text-ink placeholder:text-ink/60 focus:border-accent/50 focus:outline-none"
			{...props}
		/>
		{value && (
			<button
				type="button"
				className="absolute top-1/2 right-2 -translate-y-1/2 text-xs text-muted transition-colors hover:text-ink"
				onClick={() => onChange("")}
				aria-label="Очистить поиск"
			>
				✕
			</button>
		)}
	</div>
);
